import { types as t } from 'mobx-state-tree';
import qs from 'qs';

import Meta from './Meta';

import localeEN from '../locale/en.js';
import localeFR from '../locale/fr.js';
import localeIS from '../locale/is.js';
import localeNO from '../locale/no.js';
import localePL from '../locale/pl.js';
import localeSV from '../locale/sv.js';
import { scTheme } from '../theme';

const locale = {
  en: localeEN,
  is: localeIS,
  pl: localePL,
  no: localeNO,
  sv: localeSV,
  fr: localeFR,
};

const Theme = t.model('Theme', {
  primaryColor: t.maybe(t.string),
  primaryColorDarker: t.maybe(t.string),
  secondaryColor: t.maybe(t.string),
  buttonTextColor: t.maybe(t.string),
  buttonBorderRadius: t.maybe(t.string),
  backgroundPrimary: t.maybe(t.string),
  formInputColor: t.maybe(t.string),
  fontFamily: t.maybe(t.string),
  secondFont: t.maybe(t.string),
  textColor: t.maybe(t.string),
  headingColor: t.maybe(t.string),
  headingHoverColor: t.maybe(t.string),
  linkColor: t.maybe(t.string),
  formLabelColor: t.maybe(t.string),
  errorColor: t.maybe(t.string),
  subHeadingColor: t.maybe(t.string),
  listBgHoverColor: t.maybe(t.string),
  logoHeight: t.maybe(t.string),
  categoryHeaderColor: t.maybe(t.string),
  formBackgroundColor: t.maybe(t.string),
  pageBackgroundColor: t.maybe(t.string),
  formIconColor: t.maybe(t.string),
  formFieldBg: t.maybe(t.string),
  formFieldBgHover: t.maybe(t.string),
  white: t.maybe(t.string),
  purple100: t.maybe(t.string),
  purple90: t.maybe(t.string),
  purple80: t.maybe(t.string),
  purpleTrans10: t.maybe(t.string),
  purpleTrans5: t.maybe(t.string),

  meta: t.maybe(Meta),
  bp: t.frozen(),
});

const UIStore = t
  .model('UIStore', {
    language: 'is',
    theme: t.optional(Theme, scTheme),
    selectedJob: t.maybe(t.string),
    uuid: t.maybe(t.string),
  })
  .views((self) => ({
    get t() {
      return (str, ...args) => {
        if (str === '' || str === undefined || str === null) {
          return '';
        }

        let s = locale[self.language][str];
        if (!s) {
          console.error(`Missing translation for string: ${str}, in language: ${self.language}`);
          return '';
        }
        if (args.length === 0) return s;

        let i = 0;
        if (s) {
          for (let arg of args) {
            let index = '{' + i + '}';
            s = s.replace(index, arg);
            i++;
          }
        }
        return s;
      };
    },
  }))
  .actions((self) => ({
    afterCreate() {
      const { preview } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
      if (preview) {
        self.preview = preview;
      }
    },
    clearSelectedJob() {
      self.selectedJob = undefined;
    },
    selectJob(job) {
      if (self.selectedJob !== job) {
        self.selectedJob = job;
      }
    },
    setTheme(theme) {
      Object.keys(theme).forEach((key) => {
        self.theme[key] = theme[key];
      });
    },
    setLanguage(lang) {
      if (self.language !== lang) {
        self.language = lang;
      }
    },
  }));

export default UIStore.create({});
export { UIStore };
